import React, { FC } from 'react';

interface AnimationProgressProps {
    uniqueId: string | number;
}

const AnimationProgress: FC<AnimationProgressProps> = ({ uniqueId }) => {
    return (
        <div className="Animation_progressWrapper">
            <div
                id={`AnimationProgressBar_${uniqueId}`}
                className="Animation_progress"
            >
                <div className="Animation_progression" />
            </div>
        </div>
    );
};

export default AnimationProgress;
